import { Dealer, DealerAddress } from '@api/types';
import { PlaceType, SearchDealerOption } from '@components';
import { getGeocode, getLatLng } from 'use-places-autocomplete';

export const getPublicAddress = (dealerData?: Dealer): DealerAddress | undefined => {
  return dealerData?.address?.find((address) => address.addressType.includes('Public'));
};

export const parseDealerData = (dealerData: Dealer): SearchDealerOption => {
  const publicAddress = getPublicAddress(dealerData);
  const address = publicAddress?.line1 || '';
  const city = publicAddress?.city || '';
  const name = publicAddress?.name || '';
  return {
    name: name || '',
    lat: dealerData.latitude || 0,
    lng: dealerData.longitude || 0,
    type: 'dealer',
    id: dealerData.id || '',
    address,
    city,
  };
};

export const parsePlaceData = async (placesData: PlaceType): Promise<SearchDealerOption> => {
  const results = await getGeocode({ address: placesData.description });
  const { lat, lng } = getLatLng(results[0]);
  return {
    name: placesData.description || '',
    lat,
    lng,
    type: 'place',
    id: placesData.place_id,
  };
};
